__turbopack_context__.v({
  "placeholder": "ProductTeaser-module-scss-module__ZYRZta__placeholder",
  "placeholderType": "ProductTeaser-module-scss-module__ZYRZta__placeholderType",
});
